import { render, staticRenderFns } from "./auth_box.vue?vue&type=template&id=d6f7b266&scoped=true&"
import script from "./auth_box.vue?vue&type=script&lang=js&"
export * from "./auth_box.vue?vue&type=script&lang=js&"
import style0 from "./auth_box.vue?vue&type=style&index=0&id=d6f7b266&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f7b266",
  null
  
)

export default component.exports